<app-header-one [sticky]="true"></app-header-one>

<!-- Home slider start-->
<div class="p-0 body-section">
    <app-slider [sliders]="bannerItems" [textClass]="'text-center'" [category]="'chair'" [buttonText]="'shop now'">
    </app-slider>
</div>
<!-- Home slider End -->

<!-- collection banner start-->
<!-- <section>
    <div class="container">
        <div class="row">
            <div class="col-md-10 offset-md-2">
                <div class="row partition2">
                    <div class="col-md-5" *ngFor="let collection of collections">
                        <a [routerLink]="['/shop/collection/left/sidebar']" [queryParams]="{ category: 'fashion'}">
                            <div class="collection-banner p-right text-center">
                                <img [src]="collection.image" class="img-fluid" alt="collection-banner">
                                <div class="contain-banner">
                                    <div>
                                        <h4>{{collection.save}}</h4>
                                        <h2>{{collection.title}}</h2>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- collection banner End -->

<!-- Product slider start-->
<!-- <div class="title1 py-3">
    <h4>special offer</h4>
    <h2 class="title-inner1">top collection</h2>
</div>
<div class="container">
    <div class="row">
        <div class="col-lg-6 offset-lg-3">
            <div class="product-para">
                <p class="text-center">
                    Enhancing your world
                    with our designs.The company owns and operates 7 brands namely Elomelo, Style Girl, A Sweet Design,
                    Elly Ross, Style Plus, Denim Studio and Active Spirits, each with their own distinct identity. All
                    these branded garments are especially designed and crafted by a well trianed team of in-house
                    designers.
                </p>
            </div>
        </div>
    </div>
</div> -->
<section>
    <div class="container">
        <div class="row">
            <div class="col">
                <owl-carousel-o class="product-m no-arrow" [options]="ProductSliderConfig">
                    <ng-container *ngFor="let product of productskartselling | slice:0:500">
                        <ng-template carouselSlide>
                            <div class="product-box">
                                <!--src\app\shared\components\product\product-box -->
                                <app-product-box [productkart]="product" [currency]="productService?.Currency"
                                    [thumbnail]="true">
                                </app-product-box>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>
<!-- Product slider End -->
<section>
    <div class="count-sec count-sec-nopadding red-bg" style="background-color: #2874f0;
    padding: 14px;">
        <div class="container">
            <div class="wrapper clearfix">
                <div class="col-sm-12 shipping-count">
                    <h2 class="white-color nomargin" style="color: white;
                    text-align: right;"><span style="font-family: Roboto,sans-serif;font-weight: 700;font-size: .5em;"
                            class="vertically-center">CURRENTLY DELIVERING PACKAGE
                            NUMBER:</span> <span id="curr_delivered_packts"
                            style="display: inline-block; vertical-align: middle;">{{TodayCounter | date
                            :'Mdmm'}}</span>
                    </h2>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Parallax banner start-->
<!-- commented on18 july  by deepak-->
<!-- <section>
    <div class="full-banner parallax-banner1 parallax text-center p-left"
        [ngStyle]="{'background-image': 'url(assets/images/parallax/1.jpg)'}">
       
        <div class="container">
            <div class="row">
                <div class="col">
                    <div class="banner-contain">
                        <h2>2023</h2>
                        <h3>New trends</h3>
                        <h4>special offer</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- Parallax banner End -->

<!-- Tab product start-->
<div class="title1 py-3">
    <h4>exclusive products</h4>
    <h2 class="title-inner1">special products</h2>
</div>
<!-- <section> // commented on 3 aug 2023 as it is no longer used.
    <div class="container">
        <div class="row">
            <div class="col theme-tab">
                <ngb-tabset [justify]="'center'" [type]="'pills'" class="tabs tab-title">
                    <ngb-tab *ngFor="let collection of productCollections">
                        <ng-template ngbTabTitle>{{collection.name}}</ng-template>
                        <ng-template ngbTabContent>
                            <div class="no-slider row">
                                <ng-container *ngFor="let product of getCollectionProducts(collection) | slice:0:500">
                                    <div class="product-box">
                                        <app-product-box [productkart]="product" [currency]="productService?.Currency">
                                        </app-product-box>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-template>
                    </ngb-tab>
                </ngb-tabset>
            </div>
        </div>
    </div>
</section> -->
<!-- Tab product End -->

<section>
    <div class="container">
        <div class="row">
            <div class="col">

                <div class="p-10" *ngFor="let cat of lstCategory">
                    <div class="product-box">
                        <app-block-sub-category [title]="cat.title" [categoryID]="cat.CategoryId"
                            [lstSubcategory]="cat.children">
                        </app-block-sub-category>
                    </div>
                </div>
                <div class="theme-card mb-5">
                    <h5 class="title-border">Video</h5>

                    <owl-carousel-o class="offer-slider">
                        <ng-container>
                            <ng-template *ngFor="let product of lstProductVideoUrl" carouselSlide>
                                <!-- {{product.videoURL}} -->
                                <div class="box-design">

                                    <youtube-player [videoId]="product.videoURL" suggestedQuality="small"
                                        [startSeconds]="startSeconds" [endSeconds]="endSeconds" [height]="height"
                                        [width]="width">
                                    </youtube-player>


                                    <!-- <youtube-player [videoId]="product.videoURL" suggestedQuality="small">
                                    </youtube-player> -->
                                    <!-- <video controls="controls" x-webkit-airplay="allow" class="product-image__img">
                                        <source [src]="updateVideoUrl(product.videoURL)" type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video> -->
                                    <!-- <iframe width="560" height="315" [src]="updateVideoUrl(product.videoURL)"
                                        frameborder="0" allowfullscreen></iframe> -->
                                    <!-- <iframe width="320" height="315" [src]="product.videoURL">
                                    </iframe> -->
                                </div>
                                <div class="product-card__info">
                                    <div class="product-card__name">
                                        {{product.productName}}
                                        <!-- <a appClick [routerLink]="'#'">{{ product.productName}}</a> -->
                                    </div>

                                </div>

                            </ng-template>

                        </ng-container>
                    </owl-carousel-o>
                    <!-- <h2>Render youtube video</h2>
                    <youtube-player [videoId]="videoId" suggestedQuality="small"> </youtube-player> -->
                </div>
            </div>
        </div>
    </div>
</section>
<!-- services start-->
<div class="container">
    <section class="service border-section small-section d-none">
        <!-- <app-services></app-services> -->
    </section>
</div>
<!-- services End -->

<!-- blog section start-->
<!-- <section class="blog p-t-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="title1 section-t-space">
          <h4>Recent Story</h4>
          <h2 class="title-inner1">from the blog</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-blog [blogs]="blog"></app-blog>
      </div>
    </div>
  </div>
</section> -->
<!-- blog section End -->
<!-- Cusotmer Story 

<section class="instagram" *ngIf="lstData.length>0">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 p-0">
                <h2 class="title-borderless">Customer Stories</h2>

                <owl-carousel-o [options]="InstaSliderConfig" class="no-arrow instagram">
                    <ng-container *ngFor="let lst of lstData">
                        <ng-template carouselSlide>
                            <div>
                                <div class="instagram-box">
                                    
                                    <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
                                        [lazyLoad]="ImageSrc ? ImageSrc : APIURL+'/CustomerStoryImages/'+lst.customerStoryId+'/'+lst.imagePath"
                                        class="img-fluid lazy-loading" alt="Avatar" />
                                    <div class="overlay">
                                        <i class="fa fa-instagram" aria-hidden="true">{{lst?.notes}}</i>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>

            </div>
        </div>
    </div>
</section>
<section class="instagram" *ngIf="lstData.length>0">
    <div class="container-fluid">
        <div class="col-sm-12 empty-cart-cls text-center">
           
            <div class="text-center">
                <a [routerLink]="['/shop/customerStories']" class="btn btn-solid">View More Customer Stories</a>
            </div>
        </div>
    </div>
</section>-->

<!-- Customer Story -->

<!-- Instagram section -->
<br>
<br>
<section class="instagram">
    <div class="container-fluid ">
        <div class="row">
            <div class="col-md-12 p-0">
                <h2 class="title-borderless">Our Courier Partners</h2>
                <!-- <app-instagram></app-instagram> -->

                <owl-carousel-o [options]="InstaSliderConfig" class="no-arrow instagram">
                    <ng-container *ngFor="let img of Courier">
                        <ng-template carouselSlide>
                            <div>
                                <!-- <a [href]="insta.link"> -->
                                <div class="instagram-box">
                                    <img [src]="img.CourierImage" alt="Avatar" style="width:100%">
                                    <div class="overlay">
                                        <!-- <i class="fa fa-instagram" aria-hidden="true"></i> -->
                                    </div>
                                </div>
                                <!-- </a> -->
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>

            </div>
        </div>
    </div>
</section>
<!-- Instagram section End -->

<!--  logo section start-->
<!--commnented on 2 nov by deepak-->
<!-- <section>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <app-logo [logos]="logo"></app-logo>
            </div>
        </div>
    </div>
</section> -->
<!--  logo section End-->

<!-- <app-newsletter></app-newsletter> -->
<app-footer-one></app-footer-one>